import "./Profil.css";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MODIFIER_PROFIL } from "../../../Routes/NAVIGATION_PATH";
import { Container, Row, Col } from "react-bootstrap";
import tof3 from "../../../Assets/imge/istockphoto-1270067126-612x612.jpg";
import Table from "react-bootstrap/Table";
import avatar from '../../../Assets/avatar.png'
import { db, getDocument } from "../../../Firebase";
import MonBtn from "../../Commun/Btnbtn/MonBtn";
import { BsBackspace } from "react-icons/bs";

function Profil() {
  const [currentUser ,setCurrentUser] = useState({})
  const currentUserId = sessionStorage.getItem("user_id");
 useEffect(()=>{
    getDocument('users', currentUserId , setCurrentUser)
 },[])

 const myphoto = currentUser?.photo !== undefined? currentUser?.photo : avatar;

  const statisticUsers = (user_type) => {
    if (user_type === "prof" || user_type === "etudiant") {
      return (
        <>
          <tr>
            <td colSpan={3}>Tel</td>
            <td>{currentUser?.tel}</td>
          </tr>
          <tr>
            <td colSpan={3}> Domaine</td>
            <td>{currentUser?.domaine}</td>
          </tr>
        </>
      );
    }
  };
  return (
    <div className="profil">
      <div className="profile p">
        
        <h2 className="text-uppercase ps-3">Informations Générales</h2>
        <div className="" style={{ background: "#FFF" }}>
        <div className="d-flex justify-content-start mx-4 pt-2 ">
          <MonBtn style={{ backgroundColor: "blue" }}> <BsBackspace /> Dashbord</MonBtn>
        </div>
          <Container fluid>
            <Row className="py-5 mx-0">
              <Col lg={4} className="text-center blocProfil">
                <img src={myphoto} alt="tof3" className="imgprofil" />

                <div className="vvd">
                  <div className="textsapn text-capitalize">
                    {currentUser?.prenom} {currentUser?.nom}
                  </div>{" "}
                  <div className="textsapn">{currentUser?.user_type}</div>
                  <Link
                    to={MODIFIER_PROFIL}
                    variant="primary"
                    className="btnn btn btn-md text-white mb-3"
                  >
                    Modifer Profile
                  </Link>
                </div>
              </Col>
              <Col lg={8} className="ps-md-5">
                <Table responsive className="tabl ps-md-5">
                  <tbody className="text-capitalize">
                    <tr className="info">
                      <td colSpan={3} className="info">
                        <span style={{ color: "white" }}>
                          Informations Générales
                        </span>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colSpan={3}>Prenom</td>
                      <td>{currentUser?.prenom}</td>
                    </tr>

                    <tr>
                      <td colSpan={3}>Nom</td>
                      <td>{currentUser?.nom}</td>
                    </tr>
                    <tr>
                      <td colSpan={3}>Résidence</td>
                      <td>{currentUser?.residence}</td>
                    </tr>
                    <tr>
                      <td colSpan={3}>E-mail</td>
                      <td>{currentUser?.email}</td>
                    </tr>
                    <tr>
                      <td colSpan={3}>Statut</td>
                      <td>{currentUser?.user_type}</td>
                    </tr>
                    {statisticUsers(currentUser?.user_type)}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
}

export default Profil;
